import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _acceptAllJoinRequestsInAdministratedGroupsRequest = {};
var _acceptAllJoinRequestsInAdministratedGroupsResponse = {
    members: '_groupMember',
};
var _acceptJoinRequestsRequest = {};
var _acceptJoinRequestsResponse = { groupMember: '_groupMember' };
var _addGroupMembersRequest = {};
var _addGroupMembersResponse = { members: '_groupMember' };
var _aggregation = {
    range: '_rangeAggregation',
    nested: '_nestedAggregation',
};
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _aggregationResultsScalarResult = { value: 'DOUBLE' };
var _cleanupGroupMembersRequest = {};
var _cleanupGroupMembersResponse = {};
var _countGroupMembersByGroupsRequest = {};
var _countGroupMembersByGroupsResponse = {};
var _cursorSearch = { aggregations: '_aggregation' };
var _getGroupMemberRequest = {};
var _getGroupMemberResponse = { groupMember: '_groupMember' };
var _getJoinRequirementsRequest = {};
var _getJoinRequirementsResponse = {};
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _groupMember = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _groupMembers = { members: '_groupMember' };
var _healGroupMembersRequest = {};
var _healGroupMembersResponse = {};
var _joinGroupRequest = {};
var _joinGroupResponse = { groupMember: '_groupMember' };
var _leaveGroupRequest = {};
var _leaveGroupResponse = { groupMember: '_groupMember' };
var _nestedAggregation = { nestedAggregations: '_nestedAggregationItem' };
var _nestedAggregationItem = { range: '_rangeAggregation' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultValue = { range: '_rangeResult', scalar: '_scalarResult' };
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _queryGroupMemberCountsInternalRequest = {};
var _queryGroupMemberCountsInternalResponse = {};
var _queryGroupMembersInternalRequest = {};
var _queryGroupMembersInternalResponse = { members: '_groupMember' };
var _queryGroupMembersMultiTenantRequest = {};
var _queryGroupMembersMultiTenantResponse = { members: 'Map#_groupMembers' };
var _queryGroupMembersRequest = {};
var _queryGroupMembersResponse = { members: '_groupMember' };
var _queryMyMembershipRequest = {};
var _queryMyMembershipResponse = { members: '_groupMember' };
var _queryNonGroupMembersRequest = {};
var _queryNonGroupMembersResponse = { members: '_groupMember' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _rejectAllJoinRequestsInAdministratedGroupsRequest = {};
var _rejectAllJoinRequestsInAdministratedGroupsResponse = {
    members: '_groupMember',
};
var _rejectJoinRequestsRequest = {};
var _rejectJoinRequestsResponse = { groupMember: '_groupMember' };
var _removeGroupMembersRequest = {};
var _removeGroupMembersResponse = { members: '_groupMember' };
var _results = { results: 'Map#_nestedResultValue' };
var _scalarResult = { value: 'DOUBLE' };
var _searchGroupMembersRequest = { search: '_cursorSearch' };
var _searchGroupMembersResponse = {
    members: '_groupMember',
    aggregationData: '_aggregationData',
};
var _setGroupMembersRoleRequest = {};
var _setGroupMembersRoleResponse = { groupMembers: '_groupMember' };
var _withdrawJoinRequestRequest = {};
var _withdrawJoinRequestResponse = { groupMember: '_groupMember' };
function resolveWixSocialgroupsV3GroupMembersServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/groupmembers',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups/v3/group-members',
                destPath: '/v3/group-members',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v3/group-members',
                destPath: '/v3/group-members',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups/v3/group-members',
                destPath: '/v3/group-members',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/social-groups/v3/group-members',
                destPath: '/v3/group-members',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/social-groups/v3/group-members',
                destPath: '/v3/group-members',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v3/group-members',
                destPath: '/v3/group-members',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v3/group-members',
                destPath: '/v3/group-members',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/social-groups/v3/group-members',
                destPath: '/v3/group-members',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/social-groups/v3/group-members',
                destPath: '/v3/group-members',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/social-groups/v3/group-members',
                destPath: '/v3/group-members',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups/v3/group-members',
                destPath: '/v3/group-members',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Join a group as a member.
 * The service will validate if it's possible based on group members settings.
 * If admin approval is required, the service will create a pending group member.
 * If valid inviteId is provided, admin approval will be skipped and group member will be joined.
 * If there are any members questions, the service will validate the answers first.
 */
export function joinGroup(payload) {
    var _a = serializer(_joinGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_joinGroupResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __joinGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.JoinGroup',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/{groupId}/join',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __joinGroup.fromReq = fromReq;
    __joinGroup.__isAmbassador = true;
    return __joinGroup;
}
/** Leave a group as a member. */
export function leaveGroup(payload) {
    var _a = serializer(_leaveGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_leaveGroupResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __leaveGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.LeaveGroup',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/{groupId}/leave',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __leaveGroup.fromReq = fromReq;
    __leaveGroup.__isAmbassador = true;
    return __leaveGroup;
}
/** Add members to a group. */
export function addGroupMembers(payload) {
    var _a = serializer(_addGroupMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addGroupMembersResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __addGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.AddGroupMembers',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/{groupId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addGroupMembers.fromReq = fromReq;
    __addGroupMembers.__isAmbassador = true;
    return __addGroupMembers;
}
/** Accept a request to join a group. */
export function acceptJoinRequests(payload) {
    var _a = serializer(_acceptJoinRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_acceptJoinRequestsResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __acceptJoinRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.AcceptJoinRequests',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/{groupId}/requests/accept',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __acceptJoinRequests.fromReq = fromReq;
    __acceptJoinRequests.__isAmbassador = true;
    return __acceptJoinRequests;
}
/** Reject a request to join a group. */
export function rejectJoinRequests(payload) {
    var _a = serializer(_rejectJoinRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rejectJoinRequestsResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __rejectJoinRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.RejectJoinRequests',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/{groupId}/requests/reject',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rejectJoinRequests.fromReq = fromReq;
    __rejectJoinRequests.__isAmbassador = true;
    return __rejectJoinRequests;
}
/** Withdraw a request to join a group. */
export function withdrawJoinRequest(payload) {
    var _a = serializer(_withdrawJoinRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_withdrawJoinRequestResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __withdrawJoinRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.WithdrawJoinRequest',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/{groupId}/requests/withdraw',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __withdrawJoinRequest.fromReq = fromReq;
    __withdrawJoinRequest.__isAmbassador = true;
    return __withdrawJoinRequest;
}
/** Update member's role inside of group */
export function setGroupMembersRole(payload) {
    var _a = serializer(_setGroupMembersRoleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setGroupMembersRoleResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __setGroupMembersRole(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.SetGroupMembersRole',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/{groupId}/roles/assign',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setGroupMembersRole.fromReq = fromReq;
    __setGroupMembersRole.__isAmbassador = true;
    return __setGroupMembersRole;
}
/** Remove members from a group. */
export function removeGroupMembers(payload) {
    var _a = serializer(_removeGroupMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeGroupMembersResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __removeGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.RemoveGroupMembers',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/{groupId}/remove',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeGroupMembers.fromReq = fromReq;
    __removeGroupMembers.__isAmbassador = true;
    return __removeGroupMembers;
}
/** Query GroupMembers using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryGroupMembers(payload) {
    var _a = serializer(_queryGroupMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryGroupMembersResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __queryGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.QueryGroupMembers',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryGroupMembers.fromReq = fromReq;
    __queryGroupMembers.__isAmbassador = true;
    return __queryGroupMembers;
}
/** Search GroupMembers using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function searchGroupMembers(payload) {
    var _a = serializer(_searchGroupMembersRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchGroupMembersResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _aggregationResultsScalarResult: _aggregationResultsScalarResult,
        _groupByValueResults: _groupByValueResults,
        _groupMember: _groupMember,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _results: _results,
        _scalarResult: _scalarResult,
    }).fromJSON;
    function __searchGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.SearchGroupMembers',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchGroupMembers.fromReq = fromReq;
    __searchGroupMembers.__isAmbassador = true;
    return __searchGroupMembers;
}
/**
 * Query GroupMembers using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) through all sites
 * @deprecated It has been replaced with QueryGroupMembers(), and will be removed on 2024-09-28.
 */
export function queryGroupMembersMultiTenant(payload) {
    var _a = serializer(_queryGroupMembersMultiTenantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryGroupMembersMultiTenantResponse, { _groupMember: _groupMember, _groupMembers: _groupMembers }).fromJSON;
    function __queryGroupMembersMultiTenant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.QueryGroupMembersMultiTenant',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/query-multi-tenant',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryGroupMembersMultiTenant.fromReq = fromReq;
    __queryGroupMembersMultiTenant.__isAmbassador = true;
    return __queryGroupMembersMultiTenant;
}
/** Query with offset paging. Internal use only */
export function queryGroupMembersInternal(payload) {
    var _a = serializer(_queryGroupMembersInternalRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryGroupMembersInternalResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __queryGroupMembersInternal(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.QueryGroupMembersInternal',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/query-internal',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryGroupMembersInternal.fromReq = fromReq;
    __queryGroupMembersInternal.__isAmbassador = true;
    return __queryGroupMembersInternal;
}
/** Query GroupMembers using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryNonGroupMembers(payload) {
    var _a = serializer(_queryNonGroupMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryNonGroupMembersResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __queryNonGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.QueryNonGroupMembers',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/non-group-members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryNonGroupMembers.fromReq = fromReq;
    __queryNonGroupMembers.__isAmbassador = true;
    return __queryNonGroupMembers;
}
/** Query My Membership using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryMyMembership(payload) {
    var _a = serializer(_queryMyMembershipRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMyMembershipResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __queryMyMembership(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.QueryMyMembership',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/query-my-membership',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMyMembership.fromReq = fromReq;
    __queryMyMembership.__isAmbassador = true;
    return __queryMyMembership;
}
/** Get GroupMember by GroupId and ContactId */
export function getGroupMember(payload) {
    var _a = serializer(_getGroupMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getGroupMemberResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __getGroupMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.GetGroupMember',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/{groupId}/{contactId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGroupMember.fromReq = fromReq;
    __getGroupMember.__isAmbassador = true;
    return __getGroupMember;
}
/** Accept All Join Requests in All groups where caller is Admin */
export function acceptAllJoinRequestsInAdministratedGroups(payload) {
    var _a = serializer(_acceptAllJoinRequestsInAdministratedGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_acceptAllJoinRequestsInAdministratedGroupsResponse, { _groupMember: _groupMember }).fromJSON;
    function __acceptAllJoinRequestsInAdministratedGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.AcceptAllJoinRequestsInAdministratedGroups',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/requests/accept-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __acceptAllJoinRequestsInAdministratedGroups.fromReq = fromReq;
    __acceptAllJoinRequestsInAdministratedGroups.__isAmbassador = true;
    return __acceptAllJoinRequestsInAdministratedGroups;
}
/** Reject All Join Requests in All groups where caller is Admin */
export function rejectAllJoinRequestsInAdministratedGroups(payload) {
    var _a = serializer(_rejectAllJoinRequestsInAdministratedGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rejectAllJoinRequestsInAdministratedGroupsResponse, { _groupMember: _groupMember }).fromJSON;
    function __rejectAllJoinRequestsInAdministratedGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.RejectAllJoinRequestsInAdministratedGroups',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/requests/reject-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rejectAllJoinRequestsInAdministratedGroups.fromReq = fromReq;
    __rejectAllJoinRequestsInAdministratedGroups.__isAmbassador = true;
    return __rejectAllJoinRequestsInAdministratedGroups;
}
/** Get Join Requirements */
export function getJoinRequirements(payload) {
    var _a = serializer(_getJoinRequirementsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getJoinRequirementsResponse, {}).fromJSON;
    function __getJoinRequirements(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.GetJoinRequirements',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members-settings/get-join-requirements',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getJoinRequirements.fromReq = fromReq;
    __getJoinRequirements.__isAmbassador = true;
    return __getJoinRequirements;
}
/** @deprecated It has been replaced with CountGroupMembersByGroups(), and will be removed on 2024-09-27. */
export function queryGroupMemberCountsInternal(payload) {
    var _a = serializer(_queryGroupMemberCountsInternalRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryGroupMemberCountsInternalResponse, {}).fromJSON;
    function __queryGroupMemberCountsInternal(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.QueryGroupMemberCountsInternal',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/query-internal/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryGroupMemberCountsInternal.fromReq = fromReq;
    __queryGroupMemberCountsInternal.__isAmbassador = true;
    return __queryGroupMemberCountsInternal;
}
export function countGroupMembersByGroups(payload) {
    var _a = serializer(_countGroupMembersByGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countGroupMembersByGroupsResponse, {}).fromJSON;
    function __countGroupMembersByGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.CountGroupMembersByGroups',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countGroupMembersByGroups.fromReq = fromReq;
    __countGroupMembersByGroups.__isAmbassador = true;
    return __countGroupMembersByGroups;
}
export function cleanupGroupMembers(payload) {
    var _a = serializer(_cleanupGroupMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cleanupGroupMembersResponse, {}).fromJSON;
    function __cleanupGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.CleanupGroupMembers',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/{groupId}/cleanup',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cleanupGroupMembers.fromReq = fromReq;
    __cleanupGroupMembers.__isAmbassador = true;
    return __cleanupGroupMembers;
}
export function healGroupMembers(payload) {
    var _a = serializer(_healGroupMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_healGroupMembersResponse, {}).fromJSON;
    function __healGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.socialgroups.v3.group_member',
            method: 'POST',
            methodFqn: 'wix.socialgroups.v3.GroupMembersService.HealGroupMembers',
            url: resolveWixSocialgroupsV3GroupMembersServiceUrl({
                protoPath: '/v3/group-members/{groupId}/heal',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __healGroupMembers.fromReq = fromReq;
    __healGroupMembers.__isAmbassador = true;
    return __healGroupMembers;
}
//# sourceMappingURL=http.impl.js.map